<template>
    <div class="chat-box chats-chat-box">
        <!-- DEPRICATED -->

        <div class="chat-box__header" v-if="mode == 'full'">

            <div class="chat-box__header-top">
                <h2>{{ $t('common.chat') }}</h2>

                <button v-if="showChatButtonToCurrentUser || showPayButtonToCurrentUser" @click="tryShowCreateChat" class="button button is-green is-middle chat-box__new-message">
                    <span>{{ $t('common.message') }}</span>
                    <new-message />
                </button>
                <button v-if="showExportButton" @click="showChatExport" class="button button is-white is-middle chat-box__dowload message-btn" v-tooltip-directive="{ subtitle: $t('common.chatExportPdf'), hideImmediately: true }">
                    <span>{{ $t('common.download') }}</span>
                    <download-icon />
                </button>
            </div>

            <available-count class="chat-box__available" :count="availableCount" @selectAvailable="selectAvailable" />

        </div>

        <div class="chat-box__body">

            <empty-list class="chat-box__empty-list" v-if="rooms.length === 0 && pinnedIds.length === 0 && !loading" v-on:showCreate="showCreateChat"/>

            <available-count class="chat-box__available" v-if="mode == 'icon'" :count="availableCount" @selectAvailable="selectAvailable" />

            <div class="chat-box__pinned" v-if="pinned.length">
                <chat-item v-for="room in pinned"
                    :room="room"
                    :key="room.id"
                    @click.native="select(room)"
                    :isPinned="true"
                ></chat-item>
            </div>

            <chat-item v-for="room in rooms"
                   :room="room"
                   :key="room.id"
                   @click.native="select(room)"
            >

            </chat-item>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import NewMessage from "../svg/NewMessage";
    import DownloadIcon from "../svg/Download";
    import Close from '../svg/Close';
    import ChatItem from "./ChatItem";
    import EmptyList from "./EmptyList";
    import orderBy from "lodash.orderby";
    import {ArrayHelpers} from "../../../../common/ArrayHelpers";
    import { TooltipDirective } from '../../../directives/Tooltip';
    import {EventBus} from "@common/EventBus";
    import ChatTypes from "../../enums/ChatTypes";
    import { PaymentAccess } from "../../../../mixins/PaymentAccess";
    import AvailableCount from "./AvailableCount.vue"

    export default Vue.extend({
        name: "chats",
        components: {NewMessage, DownloadIcon, ChatItem, EmptyList, Close, AvailableCount},
        directives: { TooltipDirective },
        mixins: [PaymentAccess],
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            rooms() {
               return orderBy(this.$store.state.chat.rooms.list || [], [(item) => {
                    return item.lastMessage ? item.lastMessage.createdAt : item.updatedAt;
                }], ['desc']).filter((room) => {
                    return !this.pinnedIds.includes(room.id) && !room.isHidden
                });
            },
            messages() {
                return this.$store.state.chat.room.messages;
            },
            availableCount() {
                return this.$store.state.chat.groups.groups.length +
                       this.$store.state.chat.groups.channels.length;
            },
            mode() {
                return this.$store.state.chat.mode;
            },
            pinnedIds() {
                return this.$store.state.chat.groups.pinned;
            },
            pinned() {
                return this.$store.getters['chat/allRooms'].filter(item => this.pinnedIds.includes(item.id))
            },
            showChatButtonToCurrentUser() {
                const userGroupIds = this.$store.getters['groupIds'];
                const params = this.$store.getters['events/selectedEventViewParam']('chat', null);

                if (params?.groupIds) {
                    return !!ArrayHelpers.intersect(userGroupIds, params?.groupIds).length;
                }

                return true;
            },
            showExportButton () {
                return this.rooms.length > 0 && this.rooms.some((room) => room.type === ChatTypes.direct && room.lastMessage)
            },
            showPayButtonToCurrentUser() {
                const payParams = this.$store.getters['events/selectedEventViewParam']('accessPayments', null);
                return !this.showChatButtonToCurrentUser && payParams !== null;
            }
        },
        methods: {
            close() {
                this.$emit('close');
            },
            select(room) {
                this.$emit('selectRoom', room);
            },
            selectAvailable() {
                this.$emit('selectAvailable');
            },
            tryShowCreateChat() {
                if(this.showChatButtonToCurrentUser) {
                    this.showCreateChat();
                }
                else if(this.showPayButtonToCurrentUser) {
                    this.showPayMessage();
                }
            },

            showCreateChat() {
                this.$emit('showCreateChat')
            },
            showChatExport() {
                EventBus.$emit('chat/openExport');
            }
        }
    });
</script>

<style lang="scss">
    @import "../../style/chat-box.scss";
</style>
